// components/HelpModal/HelpModal.jsx
import React, { useState } from "react";
import "./HelpModal.css";
import ShortcutsTab from "./ShortcutsTab";
import FaqTab from "./FaqTab";
import ResourcesTab from "./ResourcesTab";
import ShadowTab from "./ShadowTab";
import LeitnerTab from "./LeitnerTab";

const HelpModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState("shortcuts");

  if (!isOpen) return null;

  const tabs = [
    { id: "shortcuts", label: "⌨️ کلیدهای میانبر", icon: "fa-keyboard" },
    { id: "faq", label: "❓ سوالات متداول", icon: "fa-question-circle" },
    { id: "resources", label: "📚 منابع دانلود فیلم", icon: "fa-download" },
    { id: "shadow", label: "🌙 تکنیک سایه", icon: "fa-moon" },
    { id: "leitner", label: "📖 آموزش لایتنر", icon: "fa-layer-group" },
  ];

  return (
    <div className="help-modal-overlay" onClick={onClose}>
      <div className="help-modal" onClick={(e) => e.stopPropagation()}>
        <div className="help-modal-header">
          <h2>
            <i className="fas fa-question-circle"></i>
            راهنمای ویدئو پلیر
          </h2>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="help-modal-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-btn ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <i className={`fas ${tab.icon}`}></i>
              <span>{tab.label}</span>
            </button>
          ))}
        </div>

        <div className="help-modal-content">
          {activeTab === "shortcuts" && <ShortcutsTab />}
          {activeTab === "faq" && <FaqTab />}
          {activeTab === "resources" && <ResourcesTab />}
          {activeTab === "shadow" && <ShadowTab />}
          {activeTab === "leitner" && <LeitnerTab />}
        </div>
      </div>
    </div>
  );
};

export default HelpModal;
